export const waitForCondition = async (condition, expectedValue, msec = 100, timeout?: number) => {
  const start = Date.now();
  while (condition() !== expectedValue) {
    await new Promise(r => setTimeout(r, msec));
    if (timeout && Date.now() - start > timeout) {
      break;
    }
  }
  return;
};
